
import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import { useLanguage } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  const { language } = useLanguage();
  const isChineseMode = language === 'zh-TW';

  return (
    <MainLayout>
      <div className="container py-12">
        <h1 className="text-3xl font-bold mb-8 text-center">
          {isChineseMode ? "常見問題" : "Frequently Asked Questions"}
        </h1>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            <AccordionItem value="item-1" className="bg-card rounded-lg p-2">
              <AccordionTrigger className="text-lg hover:no-underline">
                {isChineseMode 
                  ? "如何提交租屋評價？"
                  : "How do I submit a review?"
                }
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pt-2">
                {isChineseMode 
                  ? "您需要先登入帳號，然後點選「我要分享」頁面，填寫相關資訊即可提交評價。我們重視每一位用戶的真實體驗分享。"
                  : "Log in to your account, navigate to the 'Submit' page, and fill out the review form with details about your rental experience."
                }
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="bg-card rounded-lg p-2">
              <AccordionTrigger className="text-lg hover:no-underline">
                {isChineseMode 
                  ? "如何查看特定地區的評價？"
                  : "How can I view reviews for a specific area?"
                }
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pt-2">
                {isChineseMode 
                  ? "在「評價地圖」頁面中，您可以透過地圖介面或搜尋功能找到特定地區的租屋評價。"
                  : "On the 'Reviews Map' page, you can use the map interface or search function to find reviews for specific areas."
                }
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="bg-card rounded-lg p-2">
              <AccordionTrigger className="text-lg hover:no-underline">
                {isChineseMode 
                  ? "評價是否會被審核？"
                  : "Are reviews moderated?"
                }
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pt-2">
                {isChineseMode 
                  ? "是的，為確保平台內容的品質，所有評價都會經過基本審核，確保符合社群準則。"
                  : "Yes, all reviews go through basic moderation to ensure they comply with our community guidelines."
                }
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4" className="bg-card rounded-lg p-2">
              <AccordionTrigger className="text-lg hover:no-underline">
                {isChineseMode 
                  ? "如何舉報不實或不當的評價？"
                  : "How can I report inappropriate reviews?"
                }
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pt-2">
                {isChineseMode 
                  ? "請將相關評價的詳細資訊寄至 customer.service@trustay.app，我們將進行調查處理。"
                  : "Please email the details of the review to customer.service@trustay.app and we will investigate the matter."
                }
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </MainLayout>
  );
};

export default FAQ;
